enum HistoryOperation {
	Undefined,
	Add,
	Replace,
	Remove
}

export default HistoryOperation;
